/**
 * Looks up a business rule value by name, ignoring case.
 * Supports a name→value map and an array of {name, value}.
 *
 * @param {Object|Array} rules
 * @param {string} ruleName
 * @returns {*|null}
 */
export const getBusinessRuleValueIgnoreCase = (rules, ruleName) => {
  if (!rules || !ruleName) return null;

  const target = ruleName.toLowerCase();

  if (Array.isArray(rules)) {
    const match = rules.find((rule) => rule?.name?.toLowerCase() === target);
    return match?.value ?? null;
  }

  if (typeof rules === 'object') {
    const key = Object.keys(rules).find((k) => k.toLowerCase() === target);
    return key != null ? rules[key] : null;
  }

  return null;
};
